import React from 'react';

import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

const SectionLoader = ({ height = 240, size = 28 }) => (
  <Box
    width='100%'
    display='flex'
    alignItems='center'
    justifyContent='center'
    height={height}
  >
    <CircularProgress size={size} />
  </Box>
);

SectionLoader.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.number,
};

export default SectionLoader;
